import Header from '../Header/Header'
import InfoButton from '../InfoButton/InfoButton'
import PopOut from '../PopOut/PopOut'
import classes from './HelpPopOut.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  children: ReactNode
  title?: ReactNode
}

const triggerInfoButton = (ref: any, onClick: () => void, isOpen?: boolean) =>
  <InfoButton
    isManualFocus={isOpen}
    onClick={onClick}
    ref={ref}
    withTooltips={false} // when info button is placed at the bottom, visibility of tooltips will cause vertical scrollbar to be visible and then the button is hard to click
  />

const HelpPopOut = ({
  children,
  title
}: Props) =>
  <PopOut
    placement='bottom-end'
    trigger={triggerInfoButton}
  >
    <div
      aria-labelledby='HelpPopOut'
      className={classes.HelpPopOut}
    >
      {
        title &&
          <div className={classes.Banner}>
            <Header
              hasNoTopMargin
              lessWeight
              rank={3}
            >
              {title}
            </Header>
          </div>
      }
      <div className={classes.Content}>
        {children}
      </div>
    </div>
  </PopOut>

export default HelpPopOut
